(function ($){

    // Получение и вывод результатов поиска
    function getSearchResult(load_data) {
        var words = ( $('#search').val() !== '' ) ? $('#search').val() : '';
        var category        = [];
        var links           = [];
        var cat_title       = [];
        var page            = 1;
        var first_page_url  = $('#posts').attr('data-term-slug');
        var catalog_url;

        if ( $(".all_categories").hasClass('all_cat_hover') ) {
            $(".categories li").each(function(e){
                if($(this).hasClass('cat_hover')) {
                    category[category.length] = $(this).attr('rel');
                    links[links.length] = $(this).attr('data-url');
                    cat_title[cat_title.length] = $(this).text();
                }
            });

        } else if ( words !== '') {
            category = '';
        } else {
            category = '';
            catalog_url = $('.all_categories').attr('data-url');
            window.location.href = catalog_url;
            return false;
        }

        if (links.length === 1) window.history.pushState(null, null , links[0]);

        if ( load_data === undefined ) {
            load_data = {
                action: 'inov_load_archive',
                security: localization.ajax_nonce,
                post_cat: category,
                keyword: words,
                page_num: page,
                first_page_url: first_page_url
            };
        }

        send_ajax(load_data);
    }

    function send_ajax(load_data){

        console.log(load_data);
        
        $.ajax( {
            type: 'post',
            url: localization.ajaxurl,
            data: load_data,
            success: function( response ) {
                response = JSON.parse( response );
                if ( response.status === 'fail' ) {
                    $( '#posts' ).html( "Ничего не найдено :(" );
                    $('.page-navigation').html('');
                } else if ( response.status === 'success' ) {
                    $( '#posts' ).html( response.posts );
                    $('.page-navigation').html( response.pagination );
                } else {
                    $( '#posts' ).html( response.message );
                }
            },
            error: function( response, textStatus, errorThrown ) {
                console.log( textStatus );
            }

        } );
    }


    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    function calc_cats_number() {
        //Calculate number of categories
        var n = $('.categories ul li').length;

        if ( $.cookie('marker') == '1' ){
            $(".all_categories").addClass('all_cat_hover');

            for (var i=0; i<n; i++){
                if ($.cookie('marker' + i) == '1'){
                    $('.categories li:nth-child('+(i+1)+')').addClass('cat_hover');
                }
                else{
                    $('.categories li:nth-child('+(i+1)+')').removeClass('cat_hover')
                }
            }
        } else {
            $( ".all_categories" ).removeClass('all_cat_hover');
            var categ = getUrlParameter('cat');

            if (categ) {
                $(".all_categories").addClass('all_cat_hover');
                $(".categories li").removeClass("cat_hover");
                $(".categories").find($("li[rel=" + categ + "]")).addClass("cat_hover");
            }
        }

        return n;
    }

    //каталог - выбор категории
    var noSelectAll = true;

    // Все категории
    $(".all_categories").click(function(e){

        var catalog_url = $(this).attr('data-url');

        if ( catalog_url !== '' && typeof catalog_url !== 'undefined' ) {
            window.history.pushState(null, null , catalog_url);
            window.location.href = catalog_url;
        }
        
        /*
        var n = calc_cats_number();

        //  if (noSelectAll)
        //      return false;

        if ($(this).hasClass('all_cat_hover')){
            $(this).removeClass('all_cat_hover');
            $(".categories li").removeClass('cat_hover');
            for (var i=0; i<n; i++){
            	$.cookie('marker' + i, '0');
            }
        }
		$.cookie('marker', $(".all_categories").hasClass('all_cat_hover') ? '1' : '0');
        window.history.pushState(null, null , catalog_url);
        window.location.href = catalog_url;
        getSearchResult();
        return false;
        */
    });

    // Выбор конкретной категории
    
    $(".categories li").click(function(){

        $('.category_link').removeClass('cat_hover');

        $(this).addClass('cat_hover');
        
        $(".all_categories").addClass('all_cat_hover');

		$.cookie('marker' + $(this).index(), $(this).hasClass('cat_hover') ? '1' : '0');

        var flag1=true;
        var flag2=false;
        $(".categories li").each(function(e){
            flag1 &= $(this).hasClass('cat_hover');
            flag2 |= $(this).hasClass('cat_hover');
        });

        if (flag1){
            $(".categories li").removeClass('cat_hover');
            $('.all_categories').removeClass('all_cat_hover');
        }
        else if (!flag2){
            $(".all_categories").removeClass('all_cat_hover');
        }
        noSelectAll = !flag2;
		$.cookie('marker', $(".all_categories").hasClass('all_cat_hover') ? '1' : '0');
        getSearchResult();
        return false;
    });
    


    $(document).on('click', '#ajaxNavig a', function(event){
        event.preventDefault();
        getSearchResult($(this).attr('rel'));
    });

    $('#search').on('blur', function (){
        getSearchResult();
    });

    $('#do_search').click(function(e){
        e.preventDefault();
        getSearchResult();
    });

    $('figure.page-navigation').on('click', 'a.ajax-nav', function (e){
        e.preventDefault();

        var ajaxurl     = localization.ajaxurl;
        var url         = $(this).attr('href');
        var urlarray    = url.split("/").reverse();
        var page        = 1;
        if ($.isNumeric(urlarray[0])) {
            page        = urlarray[0]*1;
        }
        var category    = [];

        $(".categories li").each(function(e){
            if($(this).hasClass('cat_hover')) {
                category[category.length] = $(this).attr('rel');
            }
        });

        var load_data = {
            action: 'inov_load_archive',
            security: localization.ajax_nonce,
            post_cat: category,
            page_num: page,
        };

        //console.log(load_data);

        send_ajax(load_data);

        goToByScroll("#posts");

    });



})(jQuery);

